import React, {useState} from 'react';
import '../styling/containerStyles.css'
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Label from '../components/label';
// import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ButtonComp from '../components/button';
// import paytmLogo from '../assets/images/paytmLogo.png';
// import bankLogo from '../assets/images/bankLogo.png';
// import fccPointsLogo from '../assets/images/fccPointsLogo.png';
// import paytmLogo from '../assets/images/paytmLogo.svg';
import bankLogo from '../assets/images/bankLogo.svg';
import fccPointsLogo from '../assets/images/fccPointsLogo.svg';
// import pidiliteBlueLogo from '../assets/images/pidiliteBlueLogo.png';
// import saathiLogo from '../assets/images/saathiLogo.png';
// import feviSealLogo from '../assets/images/feviSealLogo.png';
import leftChevron from '../assets/images/leftChevron.svg';
import rupessIcon from '../assets/images/rupessIcon.svg';
import pointIcon from '../assets/images/pointIcon.svg';  
// import pidiliteTopBanner from '../assets/images/pidiliteTopBanner2.png';


interface TransactionDetailsProps{
    amount:string;
    redeemPoints: boolean;
    conversions: Array<any>;
    handleToProceed:Function;
    userType: string;
    banner: any;
}

export const TransactionDetails: React.FC<TransactionDetailsProps> = (props: TransactionDetailsProps) =>{

    const{
        handleToProceed, amount, redeemPoints, conversions, userType, banner
    } = props;

    const [value, setValue] = useState('')
    const [amt, setAmt] = useState('')
    // const user = userType === 'FCC'? 'FCC' : 'CWC';
    const user = userType;
    const redeemableAmt = parseFloat(amount)
    
    const wallet = String((redeemableAmt*parseFloat(conversions[0])).toFixed(2))
    const bank =   String((redeemableAmt*parseFloat(conversions[1])).toFixed(2))
    const points = String((redeemableAmt*parseFloat(conversions[2])).toFixed(2))
    const p_to_r = String((redeemableAmt*parseFloat(conversions[3])).toFixed(2))

    const handleClick = (option: any) => {
        if(option === 'GoBack'){
            handleToProceed(option)
        }
        if(value !== ''){
            handleToProceed(value, amt)
        }
        
    }
    
    const handleRadioChange = (event: any) => {
        let val = event.target.value;
        setValue(val)
        
        if(val === 'paytm'){            
            setAmt(wallet)
        }
        else if( val === 'bankAccount'){
            setAmt(bank)
        }
        else if(val === 'fccPoints'){
            setAmt(points)
        }
    };

        
        return (
            <div className='homeWrap'>
                <div className='homeTop'>
                    {/* <div className='homeTopInner'>
                        <img src={pidiliteBlueLogo} alt='Pidilite Blue Logo' className='pidiliteLogo'/>
                        <img src={saathiLogo} alt='Saathi Logo' className='saathiLogo'/>
                        <div className='productLogoWrap'>
                            <img src={feviSealLogo} alt='Product Logo' className='productLogo'/>
                        </div>
                    </div> */}
                    <div className='homeTopBanner'>
                        <img src={banner} alt='Pidilite Top Banner' className='pidiliteTopBanner'/>
                    </div>
                </div>
                <div className='transactionDetails'>
                    <div className='buttonAndLabel'>
                        <Button  className='goBack back-btn' 
                        // onClick={() => {handleToProceed('GoBack')}}
                         >
                            {/* <ArrowBackIosIcon /> */}
                            <img src={leftChevron} alt='Left Chevron' className='leftChevron'/>
                        </Button>
                        <Label content='Transaction Details' />
                    </div>
                    {/* <br></br> */}
                    <div className='sideText'>Choose your method of transaction below</div>    

                    <div className='creditValueWrap'>
                        <div className='creditValueWrapInner'>
                            <p className='creditValueText'>Credit Value</p>  
                            <div className='creditValueRupessWrap'>
                                <img src={rupessIcon} alt='Rupess Icon' className='rupessIcon'/> 
                                <p>{p_to_r}</p>
                            </div>
                            <div className='creditValuePointsWrap'>
                                <img src={pointIcon} alt='Point Icon' className='pointIcon'/> 
                                <p>{points} Pts</p>
                            </div>
                        </div>
                    </div>                
                    
                    {!redeemPoints &&
                    <div>
                        <RadioGroup aria-label="quiz" name="quiz" id='payment' value={value} onChange={handleRadioChange}> <br></br> 
                            {/* <FormControlLabel value="paytm" control={<Radio />} label={
                                <section className='menuItem'>
                                    <img className='payLogo' src = {paytmLogo} alt='paytm' ></img>
                                    <div className='payOption'>
                                        <div className='payName'>Paytm Wallet  ({"₹ " + wallet})</div>
                                        <div className='paySubName'>Use this option if you are a registered user of Paytm</div>
                                    </div>
                                </section>
                            }
                            /> <br></br>  */}
                            <FormControlLabel value="bankAccount" control={<Radio />} label={
                                <section className='menuItem'>
                                    <img className='payLogo' src = {bankLogo} alt='bank' ></img>
                                    <div className='payOption'>
                                        <div className='payName'>Bank Account  ({"₹ " + bank})</div>
                                        <div className='paySubName'>Use this option if you wish to get the amount in your bank account</div>
                                    </div>
                            </section>
                            } /> <br></br>
                            </RadioGroup>
                    </div>
                    }
                    {redeemPoints && 
                    <div>
                        
                        <RadioGroup aria-label="quiz" name="quiz" id='payment' value={value} onChange={handleRadioChange}> <br></br> 
                            {/* <FormControlLabel value="paytm" control={<Radio />} label={
                                <section className='menuItem'>
                                    <img className='payLogo' src = {paytmLogo} alt='paytm' ></img>
                                    <div className='payOption'>
                                        <div className='payName'>Paytm Wallet  ({"₹ " + wallet})</div>
                                        <div className='paySubName'>Use this option if you are a registered user of Paytm</div>
                                    </div>
                                </section>
                            }
                            /> <br></br>  */}
                            <FormControlLabel value="bankAccount" control={<Radio />} label={
                                <section className='menuItem'>
                                    <img className='payLogo' src = {bankLogo} alt='bank' ></img>
                                    <div className='payOption'>
                                        <div className='payName'>Bank Account  ({"₹ " + bank})</div>
                                        <div className='paySubName'>Use this option if you wish to get the amount in your bank account</div>
                                    </div>
                            </section>
                            } /> <br></br>
                            <FormControlLabel value="fccPoints" control={<Radio />} label={<section className='menuItem'>
                                    <img className='payLogo' src = {fccPointsLogo} alt='FCC points' ></img>
                                    <div className='payOption'>
                                        <div className='payName'>{user} Points ({points + " Points"}/ {"₹ " + p_to_r})</div>
                                        <div className='paySubName'>Use this option if you wish to redeem the coupon in the form of FCCR points</div>
                                    </div>
                            </section>} /> <br></br>
                        </RadioGroup>
                    </div>
                    }
                    <ButtonComp label= {'Proceed'} 
                                    name={'PROCEED'} 
                                    visible={true}
                                    handleToUpdate={handleClick}  />
                    </div>
            </div>         
        )
    }


export default TransactionDetails